import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getPatientGlucoseReadingsRequest = (query, params) =>
  restRequest({
    uri: 'patientGlucoseReadings',
    query,
    method: HttpMethods.Get,
    ...params,
  });
